import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

/**
 * Centered "analyzing…" block shown over the captured photos while a
 * scanner waits for the AI response: a status line, the progress bar,
 * and an optional retry message (shown when the multi-model fallback
 * switches to a different model mid-scan).
 */
@Component({
  selector: 'cs-scanner-analyzing-overlay',
  templateUrl: 'cs-scanner-analyzing-overlay.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class CsScannerAnalyzingOverlayComponent {
  /** The (possibly cycling) status line, already translated. */
  @Input() statusText = '';
  /** Fill percentage for the progress bar, 0-100. */
  @Input() progress = 0;
  /** Optional second line shown while retrying with another model. */
  @Input() retryMessage: string | null = null;
}
